import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36b34536"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "€", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "monatlich", -1))
const _hoisted_4 = { class: "interactions" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Interaktionen inklusive", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "+ 5 € je 1.000 weitere", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "check", -1))
const _hoisted_8 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "filled",
    class: _normalizeClass(["plan", { row: _ctx.row }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(_ctx.plan.name), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.plan.description), 1),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", null, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.euros) + " ", 1),
          _createElementVNode("em", null, "," + _toDisplayString(_ctx.cents), 1)
        ]),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.interactions), 1),
        _hoisted_5,
        _hoisted_6
      ]),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan.features, (feature, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(feature), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}